import { Loader2 } from 'lucide-react';

export const FullPageSpinner = () => (
  <div
    className="flex min-h-svh items-center justify-center"
    role="status"
    aria-label="Loading"
  >
    <Loader2 className="size-5 animate-spin text-ink-subtle" />
  </div>
);
